import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'keyValueFilter',
    pure: false
})
export class KeyValueFilterPipe implements PipeTransform {

    transform(items: Array<any>, key: string = '', value: string = ''): any {
        return items.filter(item => {

            const regex = new RegExp(value, 'i');

            return item[key].match(regex);
        });
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/pipes/key-value-filter.pipe.ts